/**
 * Release dates shown to operators ("To be released on …", the schedule
 * dialog) must read like every other date in the backoffice — the order
 * header renders created_at with toLocaleDateString — instead of the raw
 * ISO slice they used to be (7-Sep meeting: "fijate cómo dice el creator
 * de arriba", y la fecha en negrita).
 */
export function formatReleaseDate(value: string | null | undefined): string {
  if (!value) return "";
  const ymd = String(value).slice(0, 10);
  const [y, m, d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return ymd;
  // Construct as a LOCAL date: new Date("YYYY-MM-DD") parses as UTC midnight
  // and shows the previous day in western timezones.
  return new Date(y, m - 1, d).toLocaleDateString();
}
